import { render, staticRenderFns } from "./ScrollToTop.vue?vue&type=template&id=e44f77c0&scoped=true"
import script from "./ScrollToTop.vue?vue&type=script&lang=js"
export * from "./ScrollToTop.vue?vue&type=script&lang=js"
import style0 from "@/styles/components/ScrollToTop/ScrollToTop.less?vue&type=style&index=0&id=e44f77c0&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44f77c0",
  null
  
)

export default component.exports